import { Chip } from '@mui/material'
import styled from 'styled-components'

export const EntitlementChip = styled(Chip)`
  margin: ${(p) => p.theme.spacing(0.5)};
`

export default EntitlementChip
